export default ".cell.editable:after{content:\"\";position:relative;display:block;top:12px;left:0;right:0;width:100%;height:1px;background-color:#ff5722}";